'use es6';

export const getProfileListingDetails = state => state.profile.listing.details;
export const getProfileReviewability = state => state.profile.listing.details.reviewability;
export const getProfileListingRequestError = state => state.profile.listing.detailsRequestError;
export const getProfileListingRequestState = state => state.profile.listing.detailsRequestState;
export const getProfileReviewabilityRequestState = state => state.profile.listing.reviewabilityRequestState;
export const getProfileReviewSummaryRequestState = state => state.profile.listing.reviewSummaryRequestState;